<h3 class="ind_head">Account</h3>
<h5 class="smallheader">Account Info</h5>
<div class="account_info">
	<div class="inner_account_info">
		<img src="https://dummyimage.com/200x200/000/000" alt="img" />
		<div class="item_inner">
			<div class="item_inner_inner">
				<p class="text-xs"><span class="">{{profileDetails.tenant.uid}} </span></p>
<!--				<p class="text-xs"><span class="">{{profileDetails.tenant.id}} </span></p>-->
				<p class="name"><span class="name">{{profileDetails.tenant.name}} </span>
					<button (click)="open_pop('name')" class="name_edit_button">
						<span class="material-symbols-outlined">
							edit
						</span>
						<!-- <span class="button_text">Edit</span> -->
					</button></p>
				<p class="email">{{profileDetails.tenant.email}}</p>
				<button class="change_pass" (click)="open_pop('pass')">Change Password</button>
			</div>
		</div>
	</div>
</div>
<div class="popup_cont for_edit_name" *ngIf="hideNameChangepop">
	<div class="popup_cont_inner">
		<span (click)="close_pop('name')">X</span>
		<label>Edit Name </label>
		<form [formGroup]="changeName">

			<input type="text" placeholder="First name" formControlName="firstName" />

			<ng-container *ngIf="changeName.controls.firstName.invalid && changeName.controls.firstName.dirty">
				<p class="error_input" *ngIf="changeName.controls.firstName.hasError('required')">First name is
					required.
				</p>
			</ng-container>

			<input type="text" placeholder="Last name" formControlName="lastName" />

			<ng-container *ngIf="changeName.controls.lastName.invalid && changeName.controls.lastName.dirty">
				<p class="error_input" *ngIf="changeName.controls.lastName.hasError('required')">Last name is
					required.
				</p>
			</ng-container>

			<button (click)="nameChangeSubmit()">Save Change</button>
		</form>
	</div>
	<div class="overlay" (click)="close_pop('name')"></div>
</div>
<div class="popup_cont for_edit_name" *ngIf="hidePassChangePop">
	<div class="popup_cont_inner">
		<span (click)="close_pop('pass')">X</span>
		<label>Change Password </label>
		<form [formGroup]="passwordChange">
			<div class="form_cont">
				<input type="password" placeholder="Old Password" formControlName="password" />

				<ng-container
					*ngIf="passwordChange.controls.password.invalid && passwordChange.controls.password.dirty">
					<p class="error_input" *ngIf="passwordChange.controls.password.hasError('required')">Password is
						required.
					</p>
				</ng-container>
			</div>
			<div class="form_cont">
				<input type="password" placeholder="New Password" formControlName="confirmPassword" />

				<ng-container
					*ngIf="passwordChange.controls.confirmPassword.invalid && passwordChange.controls.confirmPassword.dirty">
					<p class="error_input" *ngIf="passwordChange.controls.confirmPassword.hasError('required')">
						Confirm
						password is
						required.
					</p>
				</ng-container>

				<ng-container
					*ngIf="passwordChange.controls.confirmPassword.dirty || passwordChange.controls.confirmPassword.touched">
					<p class="error_input"
						*ngIf="!passwordChange.controls.confirmPassword.hasError('required')&&passwordChange.controls.password.value != passwordChange.controls.confirmPassword.value">
						Password and Confirm Password mismatched</p>
				</ng-container>
			</div>

			<button (click)="updatePasswordSubmit()">Save Cahnge</button>
		</form>
	</div>
	<div class="overlay" (click)="close_pop('pass')"></div>
</div>
